import { render, staticRenderFns } from "./EmailGenerator.vue?vue&type=template&id=2df6c2ba&scoped=true"
import script from "./EmailGenerator.vue?vue&type=script&lang=js"
export * from "./EmailGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df6c2ba",
  null
  
)

export default component.exports